import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/kongzhitai-icon.png';

const _withScopeId = n => (_pushScopeId("data-v-27fd0f54"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head clearfix"
};
const _hoisted_2 = {
  ref: "pride_tab_fixed"
};
const _hoisted_3 = {
  class: "head-top"
};
const _hoisted_4 = {
  class: "head-logo"
};
const _hoisted_5 = {
  href: "/index.html"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = ["onClick"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));

const _hoisted_10 = {
  key: 2,
  class: "child-nav-out"
};
const _hoisted_11 = {
  class: "child-nav-box"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "nav-btn"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "head-infor"
};
const _hoisted_16 = ["href", "target"];
const _hoisted_17 = ["href"];
const _hoisted_18 = ["href"];

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img",
  alt: ""
}, null, -1));

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 管理后台 ");

const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = {
  key: 0,
  class: "head-login"
};
const _hoisted_23 = {
  key: 1,
  class: "head-user"
};
const _hoisted_24 = {
  class: "avatar-box"
};
const _hoisted_25 = ["src"];

const _hoisted_26 = /*#__PURE__*/_createTextVNode("账号设置");

const _hoisted_27 = /*#__PURE__*/_createTextVNode("退出");

const _hoisted_28 = {
  class: "fixPostion"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoreFilled = _resolveComponent("MoreFilled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_ArrowUp = _resolveComponent("ArrowUp");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", {
      'header-set': $props.page == '设置',
      'header-home': $data.currentPage == '首页'
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", _hoisted_5, [_createElementVNode("img", {
    src: $data.logoUrl,
    alt: ""
  }, null, 8, _hoisted_6)])]), _createElementVNode("div", {
    class: _normalizeClass(["head-btn", {
      'btn-none': $props.page == '设置'
    }])
  }, [_createElementVNode("div", {
    class: "head-nav",
    style: _normalizeStyle({
      'grid-template-columns': `repeat(${$data.navList.length}, 1fr)`
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.showNavList, ({
    nav_name,
    target_url,
    id,
    menu_id,
    target_type,
    childs,
    target_page,
    roleType
  }) => {
    return _openBlock(), _createElementBlock("div", {
      key: id,
      class: _normalizeClass(["nav-btn", $data.currentPage == nav_name ? 'nav-active' : ''])
    }, [target_page == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(nav_name), 1)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "noticenav text-overflow",
      onClick: $event => $options.handleClick(target_url, target_type, roleType)
    }, _toDisplayString(nav_name), 9, _hoisted_8)), _hoisted_9, childs && childs.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childs, (it, idx) => {
      return _openBlock(), _createElementBlock("div", {
        key: idx,
        class: _normalizeClass([{
          'child-nav-item-active': $data.currentPage === it.nav_name
        }, "child-nav-item"])
      }, [_createElementVNode("a", {
        class: "child-nav-item-name text-overflow",
        onClick: $event => $options.handleClick(it.target_url, it.target_type, it.roleType)
      }, _toDisplayString(it.nav_name), 9, _hoisted_12)], 2);
    }), 128))])])) : _createCommentVNode("", true)], 2);
  }), 128)), $options.hideNavList.length > 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 0,
    "popper-class": "hidemenu_drop"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.hideNavList, hideItem => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: hideItem.id
        }, {
          default: _withCtx(() => [_createElementVNode("a", {
            class: "noticenav",
            onClick: $event => $options.handleClick(hideItem.target_url, hideItem.target_type, hideItem.roleType)
          }, _toDisplayString(hideItem.nav_name), 9, _hoisted_14)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_icon, {
      class: "more_icon"
    }, {
      default: _withCtx(() => [_createVNode(_component_MoreFilled)]),
      _: 1
    })])]),
    _: 1
  })) : _createCommentVNode("", true)], 4)], 2), _createElementVNode("div", _hoisted_15, [$data.headList.length && ($data.zhsRole == 1 || $data.userRole == 1) ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.headList, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: "guard-center",
      key: index,
      href: item.target_url ? item.target_url : '',
      target: item.target_type ? '_blank' : '_self'
    }, _toDisplayString(item.name), 9, _hoisted_16);
  }), 128)) : _createCommentVNode("", true), $data.onlineTeache && ($data.zhsRole || $data.userRole) ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    class: "online",
    href: $data.onlineTeache ? $data.onlineTeache.target_url : '',
    target: "_blank"
  }, _toDisplayString($data.onlineTeache.name), 9, _hoisted_17)) : _createCommentVNode("", true), $data.userInfo && $data.userInfo.roleId ? (_openBlock(), _createElementBlock("a", {
    key: 2,
    class: "online",
    href: $data.backUrl,
    target: "_blank"
  }, _hoisted_21, 8, _hoisted_18)) : _createCommentVNode("", true), $data.showLogin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [!$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", {
    class: "login-btn",
    onClick: _cache[0] || (_cache[0] = $event => $options.handleLogin())
  }, "登录")])) : _createCommentVNode("", true), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        onClick: $options.goAccountSet
      }, {
        default: _withCtx(() => [_hoisted_26]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
        onClick: $options.handleExit
      }, {
        default: _withCtx(() => [_hoisted_27]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
      class: "avatar",
      src: $data.userInfo.avatar ? $data.userInfo.avatar : require('../../assets/images/user_icon.png')
    }, null, 8, _hoisted_25)])]),
    _: 1
  })])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])], 512), _withDirectives(_createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
    class: "back-top",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.backTop && $options.backTop(...args))
  }, [_createVNode(_component_el_icon, {
    size: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowUp)]),
    _: 1
  })])], 512), [[_vShow, $data.showBackTop]])])], 2);
}